const PHONE_VERIFICATION_PROMPT_SUPPRESSION_KEY =
  'phone-verification-prompt-suppressed';

type UserId = number | string;

const getStorageKey = (userId: UserId | undefined) =>
  userId === undefined
    ? undefined
    : `${PHONE_VERIFICATION_PROMPT_SUPPRESSION_KEY}:${userId}`;

export const suppressPhoneVerificationPrompt = (
  userId: UserId | undefined,
  storage: Storage = window.localStorage,
) => {
  const storageKey = getStorageKey(userId);
  if (!storageKey) return;

  storage.setItem(storageKey, 'true');
};

export const isPhoneVerificationPromptSuppressed = (
  userId: UserId | undefined,
  storage: Storage = window.localStorage,
) => {
  const storageKey = getStorageKey(userId);
  return storageKey ? storage.getItem(storageKey) === 'true' : false;
};

export const clearPhoneVerificationPromptSuppression = (
  userId: UserId | undefined,
  storage: Storage = window.localStorage,
) => {
  const storageKey = getStorageKey(userId);
  if (!storageKey) return;

  storage.removeItem(storageKey);
};
